/* WEEK EDITOR STAGE 1 — THE PAGE'S ONE WRITE: `write_week_trees(p_trees)` (migration 20261019120000), and what its refusals
 * say to a coach. The function raises `WEEK-<WORD>: …`; the word picks the sentence, so a refusal is never a raw SQL line.
 * `rpc` is injected so `weekWrite.test.ts` drives every branch without a network. */
import type { TreePayload } from "./weekEdit";
import type { WeekWriteResult } from "../components/WeekEditor";

export const WRITE_WEEK_TREES_RPC = "write_week_trees" as const;

export type WeekRpc = (fn: typeof WRITE_WEEK_TREES_RPC, args: { p_trees: TreePayload[] }) =>
  PromiseLike<{ data: unknown; error: { message: string } | null }>;

const SAID: Readonly<Record<string, string>> = {
  STALE: "This workout changed somewhere else — the week now shows the latest. Make the change again.",
  TRAINED: "That day has been trained — it is a record and stays as it was.",
  TEMPLATE: "Only a client's own workouts change here — a library workout changes in the Library.",
  CLIENTS: "Rows only move within one client's week.",
  FOREIGN: "Part of that change belongs to another workout — the week now shows the latest.",
  DROP: "That workout is not empty, so it stays.",
  AUTH: "You are signed out — sign in again to change this week.",
};

export function weekWriteSaid(message: string): { said: string; stale: boolean } {
  const m = /WEEK-([A-Z]+)/.exec(message);
  const word = m?.[1] ?? "";
  const said = SAID[word] ?? `Not saved: ${message}`;
  return { said, stale: word === "STALE" || word === "FOREIGN" };
}

export async function writeWeekTrees(rpc: WeekRpc, payloads: TreePayload[]): Promise<WeekWriteResult> {
  if (payloads.length === 0) return { ok: true, updated: {} };
  const r = await rpc(WRITE_WEEK_TREES_RPC, { p_trees: payloads });
  if (r.error !== null) return { ok: false, ...weekWriteSaid(r.error.message) };
  const updated: Record<string, string> = {};
  if (r.data !== null && typeof r.data === "object" && !Array.isArray(r.data)) {
    for (const [k, v] of Object.entries(r.data as Record<string, unknown>)) if (typeof v === "string") updated[k] = v;
  }
  return { ok: true, updated };
}
